/*
 * NANOAGRO — Caso tomate · escenas animadas (snippets ct-*, bloque "tomate" de caso-estudio)
 *
 *   intro        tomate que madura (verde → rojo), capas de montañas en paralaje, se inclina con el ratón
 *   racimo       la planta crece sola al verse (pasos por tiempo), contador de libras por planta
 *   balanza      los tomates caen en dos cestas y la balanza se inclina hacia la cosecha mayor
 *   fumigaciones semanas con 3 aplicaciones → 1
 *   ciclo        barras de 20 → 25 semanas de producción
 *   raiz         nutrientes que la raíz capta y suben hasta el fruto
 *   visitas      línea de tiempo de las tres visitas, dibujada con el scroll
 *   marquesina   franja de texto que se acelera con la velocidad del scroll
 *
 * Reglas (igual que caso-vida.js): sin librerías; las cifras se leen del DOM; sin JS o con
 * "reducir movimiento" se ve el estado final; todo arranca cuando se ve al menos el 20% del
 * bloque; los bucles se paran fuera de pantalla; un error en una escena no tumba las demás.
 */
(function () {
  'use strict';
  if (window.__cdeTomate) return;
  window.__cdeTomate = true;

  function mq(q) { return !!(window.matchMedia && window.matchMedia(q).matches); }
  var REDUCE = mq('(prefers-reduced-motion: reduce)');
  var FINO = mq('(pointer: fine)');
  var IO = 'IntersectionObserver' in window;
  var MOVIL = innerWidth < 700;

  function each(l, fn) { for (var i = 0; i < l.length; i++) fn(l[i], i); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function suave(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function sale(t) { return 1 - Math.pow(1 - t, 3); }
  function num(t) { var m = /(\d+(?:[.,]\d+)?)/.exec(String(t || '')); return m ? parseFloat(m[1].replace(',', '.')) : NaN; }

  /* Una vez, cuando se ve de verdad el bloque (≥20% o ≥30% de la pantalla si es muy alto). */
  function alVer(el, fn, espera) {
    var hecho = false;
    function ir() { if (!hecho) { hecho = true; setTimeout(fn, espera || 0); } }
    if (!IO) { ir(); return; }
    var io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) {
        var e = es[i];
        if (e.isIntersecting && (e.intersectionRatio >= .2 || e.intersectionRect.height >= innerHeight * .3)) { io.disconnect(); ir(); return; }
      }
    }, { rootMargin: '0px 0px -35% 0px', threshold: [0, .05, .1, .15, .2, .3, .5] });
    io.observe(el);
  }
  /* Avisa cuando el bloque entra/sale de pantalla (para encender y apagar bucles). */
  function vigilar(el, fn, margen) {
    if (!IO) { fn(true); return; }
    new IntersectionObserver(function (es) { fn(es[es.length - 1].isIntersecting); }, { rootMargin: margen || '120px 0px' }).observe(el);
  }
  /* Interpolación con rAF: fn(t 0..1). */
  function tween(ms, fn, fin, ease) {
    var t0 = performance.now();
    (function paso(now) {
      var t = clamp((now - t0) / ms, 0, 1);
      fn((ease || suave)(t));
      if (t < 1) requestAnimationFrame(paso); else if (fin) fin();
    })(t0);
  }
  /* Raíces del maíz: se destapan de arriba abajo (p 0..1) cambiando la altura del recorte. */
  var ALTO_RZ = 290;
  function raizP(scope, p) { each(scope.querySelectorAll('.ct-rzm__clip'), function (r) { r.setAttribute('height', (ALTO_RZ * p).toFixed(1)); }); }
  function raizCrece(scope, ms, espera) {
    raizP(scope, 0);
    setTimeout(function () { tween(ms, function (t) { raizP(scope, t); }, null, sale); }, espera || 0);
  }

  /* Un solo listener de scroll para todas las escenas que dependen de la posición. */
  var alScroll = [];
  var pedido = false;
  function onScroll() {
    if (pedido) return;
    pedido = true;
    requestAnimationFrame(function () { pedido = false; for (var i = 0; i < alScroll.length; i++) { try { alScroll[i](); } catch (e) {} } });
  }
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });

  /* ── 1. Portada ─────────────────────────────────────── */
  function intro(el) {
    var tom = el.querySelector('.ct-tom--big');
    var foto = el.querySelector('.ct-intro__foto');
    var grupo = el.querySelector('.ct-intro__tom') || foto;
    var svg = el.querySelector('.ct-intro__svg') || foto;
    if (REDUCE) return;
    el.classList.add('ct-js', 'ct-sin-tr');  // estado inicial (verde, palabras abajo) sin transición
    if (tom) tom.style.setProperty('--m', 0);
    void el.offsetWidth;
    el.classList.remove('ct-sin-tr');
    var img = foto && foto.querySelector('img');
    function conFoto(fn) {  // la maduración arranca cuando la foto ya está pintada
      if (!img || img.complete) return fn();
      img.addEventListener('load', fn, { once: true }); img.addEventListener('error', fn, { once: true });
    }
    alVer(el, function () {
      conFoto(function () {
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          el.classList.add('is-on');
          if (tom) setTimeout(function () { tween(2600, function (t) { tom.style.setProperty('--m', t.toFixed(3)); }); }, 350);
        }); });
      });
    }, 200);
    // Paralaje de las capas (montañas, niebla, invernadero)
    var vivo = false;
    vigilar(el, function (v) { vivo = v; if (v) onScroll(); });
    alScroll.push(function () { if (vivo) el.style.setProperty('--py', Math.round(-el.getBoundingClientRect().top)); });
    // El tomate mira hacia el ratón y rebota al tocarlo
    if (FINO && grupo) {
      el.addEventListener('pointermove', function (e) {
        var r = svg.getBoundingClientRect();
        var dx = clamp((e.clientX - (r.left + r.width / 2)) / r.width, -1, 1);
        var dy = clamp((e.clientY - (r.top + r.height / 2)) / r.height, -1, 1);
        grupo.style.transform = 'rotate(' + (dx * 7).toFixed(2) + 'deg) translate(' + (dx * 6).toFixed(1) + 'px,' + (dy * 4).toFixed(1) + 'px)';
      });
      el.addEventListener('pointerleave', function () { grupo.style.transform = ''; });
    }
    if (svg && grupo) {
      svg.addEventListener('click', function () {
        grupo.classList.remove('is-bote'); void grupo.getBoundingClientRect(); grupo.classList.add('is-bote');
      });
      grupo.addEventListener('animationend', function () { grupo.classList.remove('is-bote'); });
    }
  }

  /* ── 2. Racimo: la planta crece sola al verse (pasos marcados por tiempo) ── */
  function racimo(el) {
    var pasos = el.querySelector('.ct-pasos');
    var lis = el.querySelectorAll('.ct-paso');
    var tallo = el.querySelector('.ct-tallo');
    var ramas = el.querySelectorAll('.ct-rama');
    var piezas = el.querySelectorAll('.ct-hoja, .ct-flor, .ct-fruto');
    var frutos = el.querySelectorAll('.ct-fruto');
    var nEl = el.querySelector('.ct-marcador__n');
    var hasta = num(nEl && nEl.getAttribute('data-hasta'));
    var dec = /[.,](\d+)/.exec(nEl ? nEl.getAttribute('data-hasta') : '') ? RegExp.$1.length : 0;
    if (REDUCE || !pasos) { el.classList.add('is-pico'); return; }
    el.classList.add('ct-js', 'ct-auto');
    function aDe(n) { return parseFloat(n.style.getPropertyValue('--a')) || 0; }
    var umbrales = []; each(piezas, function (n) { umbrales.push(aDe(n)); });
    var umbRamas = []; each(ramas, function (n) { umbRamas.push(aDe(n)); });
    var activo = -1, n = Math.max(1, lis.length), P = 0;
    var cap = el.querySelector('.ct-racimo__cap');
    function pintar(p) {
      P = p;
      raizP(el, clamp(p / .22, 0, 1));
      if (tallo) tallo.style.strokeDashoffset = (1 - clamp(p / .42, 0, 1)).toFixed(3);
      each(ramas, function (r, i) { r.style.strokeDashoffset = (1 - clamp((p - umbRamas[i]) / .1, 0, 1)).toFixed(3); });
      each(piezas, function (r, i) { r.classList.toggle('is-on', p >= umbrales[i]); });
      each(frutos, function (r, i) { r.style.setProperty('--m', clamp((p - .74 - i * .012) / .16, 0, 1).toFixed(3)); });
      if (nEl && !isNaN(hasta)) nEl.textContent = (hasta * clamp((p - .7) / .24, 0, 1)).toFixed(dec);
      el.classList.toggle('is-pico', p > .94);
      var k = Math.min(n - 1, Math.floor(p * n));
      if (k !== activo) {
        activo = k;
        each(lis, function (li, i) { li.classList.toggle('is-on', i === k); li.classList.toggle('is-hecho', i < k); });
        if (cap && lis[k]) {
          var h = lis[k].querySelector('h3'), t = lis[k].querySelector('p');
          cap.firstChild.textContent = h ? h.textContent.trim() : '';
          cap.lastChild.textContent = t ? t.textContent.trim() : '';
        }
      }
    }
    var corriendo = 0, POR = 2600;
    function correr(desde, hastaP) {
      var id = ++corriendo, ms = Math.max(400, Math.abs(hastaP - desde) * n * POR);
      btn.hidden = true;
      tween(ms, function (t) { if (id === corriendo) pintar(desde + (hastaP - desde) * t); },
        function () { if (id === corriendo && hastaP >= 1) btn.hidden = false; }, function (t) { return t; });
    }
    /* Botón para repetir (en el idioma de la página) */
    var en = /^en/i.test(document.documentElement.lang || '');
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'ct-btn ct-racimo__otra'; btn.hidden = true;
    btn.textContent = en ? '↻ Watch it grow again' : '↻ Ver crecer otra vez';
    btn.addEventListener('click', function () { pintar(0); correr(0, 1); });
    (el.querySelector('.ct-racimo__lienzo') || pasos).parentNode.appendChild(btn);
    /* Tocar un paso lleva la planta a ese momento y sigue hasta el final */
    each(lis, function (li, i) {
      li.addEventListener('click', function () { var d = (i + .02) / n; pintar(d); correr(d, 1); });
    });
    pintar(0);
    alVer(el, function () { correr(0, 1); }, 250);
  }

  /* Última posición del ratón (para que los tomates de la balanza salgan del cursor-tomate) */
  var RATON = null;
  if (FINO) addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') RATON = { x: e.clientX, y: e.clientY }; }, { passive: true });

  /* ── 3. Balanza ─────────────────────────────────────── */
  function balanza(el) {
    var viga = el.querySelector('.ct-viga');
    var pl = el.querySelector('.ct-plato--l'), pr = el.querySelector('.ct-plato--r');
    var L = parseInt(el.getAttribute('data-l'), 10) || 10, R = parseInt(el.getAttribute('data-r'), 10) || 16;
    var nL = el.querySelector('.ct-bal__n[data-lado="l"]'), nR = el.querySelector('.ct-bal__n[data-lado="r"]');
    var btn = el.querySelector('[data-ct-otra]');
    var ang = 0;
    function angDe(l, r) { return clamp((r - l) * 1.4, -12, 12); }
    function poner(a) {
      ang = a;
      var rad = a * Math.PI / 180, c = Math.cos(rad) * 250, s = Math.sin(rad) * 250;
      if (viga) viga.setAttribute('transform', 'rotate(' + a.toFixed(2) + ' 400 110)');
      if (pl) pl.setAttribute('transform', 'translate(' + (400 - c).toFixed(1) + ' ' + (110 - s).toFixed(1) + ')');
      if (pr) pr.setAttribute('transform', 'translate(' + (400 + c).toFixed(1) + ' ' + (110 + s).toFixed(1) + ')');
    }
    poner(angDe(L, R));
    if (REDUCE) { el.classList.add('is-fin'); return; }
    el.classList.add('ct-js');
    var meta = 0, anim = null;
    function hacia(a) {
      meta = a;
      if (anim) return;
      var vel = 0;
      anim = function () {  // muelle suave: la balanza se pasa un poco y se asienta
        vel = (vel + (meta - ang) * .08) * .82;
        poner(ang + vel);
        if (Math.abs(meta - ang) > .02 || Math.abs(vel) > .02) requestAnimationFrame(anim); else { poner(meta); anim = null; }
      };
      requestAnimationFrame(anim);
    }
    var timers = [];
    function jugar() {
      each(timers, clearTimeout); timers = [];
      el.classList.remove('is-on', 'is-fin');
      var tl = pl.querySelectorAll('.ct-caida'), tr = pr.querySelectorAll('.ct-caida');
      var orden = [], i;
      for (i = 0; i < Math.max(tl.length, tr.length); i++) { if (tl[i]) orden.push(['l', tl[i]]); if (tr[i]) orden.push(['r', tr[i]]); }
      var cl = 0, cr = 0;
      nL.textContent = '0'; nR.textContent = '0';
      poner(0); meta = 0;
      // Con ratón: el primer tomate sale del cursor y salta en arco hasta la cesta de AMEN JUICE™
      var raton = !!(RATON && RATON.y > 0 && RATON.y < innerHeight);
      el.classList.toggle('is-raton', raton);
      document.documentElement.classList.remove('ct-sin-tomate');  // el cursor vuelve a tener su tomate
      // Con ratón, el PRIMER tomate es el del cursor y va a la cesta de AMEN JUICE™ (la derecha)
      if (raton) { for (i = 0; i < orden.length; i++) if (orden[i][0] === 'r') { orden.unshift(orden.splice(i, 1)[0]); break; } }
      each(orden, function (o, k) {
        var primero = raton && k === 0;
        var d = primero ? 150 : 200 + k * 150 + (raton ? 500 : 0);
        var llega = primero ? 760 : 530;
        o[1].style.setProperty('--d', d);
        o[1].classList.toggle('ct-desde-raton', primero);
        if (primero) {
          timers.push(setTimeout(function () { document.documentElement.classList.add('ct-sin-tomate'); }, d + 20));
          try {
            var m = o[1].getScreenCTM().inverse();
            var pt = o[1].ownerSVGElement.createSVGPoint(); pt.x = RATON.x; pt.y = RATON.y;
            var q = pt.matrixTransform(m);
            o[1].style.setProperty('--sx', q.x.toFixed(1) + 'px');
            o[1].style.setProperty('--sy', q.y.toFixed(1) + 'px');
          } catch (e) { el.classList.remove('is-raton'); }
        }
        timers.push(setTimeout(function () {
          if (o[0] === 'l') { cl++; nL.textContent = cl; } else { cr++; nR.textContent = cr; }
          hacia(angDe(cl, cr));
          if (k === orden.length - 1) el.classList.add('is-fin');
        }, d + llega));
      });
      void el.offsetWidth;
      el.classList.add('is-on');
    }
    nL.textContent = '0'; nR.textContent = '0'; poner(0);
    alVer(el, jugar, 150);
    if (btn) btn.addEventListener('click', jugar);
  }

  /* ── 4. Aplicaciones por semana ─────────────────────── */
  function fumigaciones(el) {
    if (REDUCE) return;
    el.classList.add('ct-js');
    alVer(el, function () {
      el.classList.add('is-on');
      setTimeout(function () { el.classList.add('is-quita'); }, 1500);
    });
  }

  /* ── 5. Ciclo ───────────────────────────────────────── */
  function ciclo(el) {
    if (REDUCE) return;
    el.classList.add('ct-js');
    var ns = el.querySelectorAll('.ct-ciclo__n');
    each(ns, function (n) { n.textContent = '0'; });
    alVer(el, function () {
      el.classList.add('is-on');
      each(ns, function (n, i) {
        var h = num(n.getAttribute('data-hasta'));
        setTimeout(function () { tween(i ? 2400 : 1800, function (t) { n.textContent = Math.round(h * t); }, null, sale); }, i ? 250 : 0);
      });
    });
  }

  /* ── 6. Bajo el suelo: nutrientes ───────────────────── */
  var COLOR = { Fe: '#E8833A', Mn: '#9B6CD6', Zn: '#4BA3C7', N: '#3FAE5A', P: '#E3B21E', K: '#D2557A' };
  function raiz(el) {
    var svg = el.querySelector('.ct-rz__svg');
    var capa = el.querySelector('.ct-part');
    if (!svg || !capa) return;
    var puntas = (svg.getAttribute('data-puntas') || '').split(';').map(function (s) { var p = s.split(','); return [+p[0], +p[1]]; });
    var els = []; each(el.querySelectorAll('.ct-rz__ley li'), function (li) { els.push(li.getAttribute('data-el')); });
    if (!els.length) els = ['Fe', 'Mn', 'Zn', 'N', 'P', 'K'];
    var frutos = el.querySelectorAll('.ct-rz__t');
    var dest = [[462, 128], [500, 140], [476, 162]];
    var NS = 'http://www.w3.org/2000/svg';
    var N = MOVIL ? 22 : 36;
    var ps = [];
    function nuevo(p, inicio) {
      p.x = 30 + Math.random() * 740; p.y = 236 + Math.random() * 220;
      var mejor = 0, md = 1e9;
      for (var i = 0; i < puntas.length; i++) { var d = Math.hypot(puntas[i][0] - p.x, puntas[i][1] - p.y); if (d < md) { md = d; mejor = i; } }
      var f = dest[(Math.random() * dest.length) | 0];
      p.ruta = [[p.x, p.y], puntas[mejor], [400 + (puntas[mejor][0] - 400) * .15, 214], [400, 150], [400, 96], f];
      p.tramo = 0; p.t = 0; p.espera = inicio ? Math.random() * 5 : 1 + Math.random() * 3; p.fase = Math.random() * 6.28;
      p.c.setAttribute('opacity', '1');
    }
    for (var i = 0; i < N; i++) {
      var c = document.createElementNS(NS, 'circle');
      var e = els[i % els.length];
      c.setAttribute('r', MOVIL ? 6 : 5.5); c.setAttribute('fill', COLOR[e] || '#999');
      capa.appendChild(c);
      var p = { c: c }; nuevo(p, true); ps.push(p);
      c.setAttribute('cx', p.x.toFixed(1)); c.setAttribute('cy', p.y.toFixed(1));
    }
    if (REDUCE) return;  // quietas en el suelo, frutos maduros
    el.classList.add('ct-js');
    var llegadas = 0, vivo = false, corriendo = false, empezado = false, t0 = 0;
    function cuadro(now) {
      if (!vivo) { corriendo = false; return; }
      var dt = Math.min(.05, (now - (t0 || now)) / 1000); t0 = now;
      for (var i = 0; i < ps.length; i++) {
        var p = ps[i];
        if (p.espera > 0) {  // flota en el suelo
          p.espera -= dt; p.fase += dt * 1.6;
          p.c.setAttribute('cx', (p.x + Math.sin(p.fase) * 4).toFixed(1)); p.c.setAttribute('cy', (p.y + Math.cos(p.fase * 1.3) * 3).toFixed(1));
          continue;
        }
        var a = p.ruta[p.tramo], b = p.ruta[p.tramo + 1];
        var largo = Math.max(1, Math.hypot(b[0] - a[0], b[1] - a[1]));
        p.t += dt * (p.tramo === 0 ? 70 : 150) / largo;
        if (p.t >= 1) {
          p.t = 0; p.tramo++;
          if (p.tramo >= p.ruta.length - 1) {  // llegó al fruto
            llegadas++;
            var m = clamp(llegadas / 40, 0, 1);
            each(frutos, function (fr, k) { fr.style.setProperty('--m', clamp(m * 1.15 - k * .08, 0, 1).toFixed(3)); });
            p.c.setAttribute('opacity', '0');
            nuevo(p, false);
            continue;
          }
          a = p.ruta[p.tramo]; b = p.ruta[p.tramo + 1];
        }
        var x = a[0] + (b[0] - a[0]) * p.t, y = a[1] + (b[1] - a[1]) * p.t;
        p.c.setAttribute('cx', x.toFixed(1)); p.c.setAttribute('cy', y.toFixed(1));
        p.c.setAttribute('opacity', p.tramo >= 2 ? '.85' : '1');
      }
      requestAnimationFrame(cuadro);
    }
    function arrancar() { if (empezado && vivo && !corriendo && !document.hidden) { corriendo = true; t0 = 0; requestAnimationFrame(cuadro); } }
    vigilar(el, function (v) { vivo = v; arrancar(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) vivo = false; else { vivo = true; arrancar(); } });
    raizP(el, 0);
    alVer(el, function () { el.classList.add('is-on'); raizCrece(el, 2200); setTimeout(function () { empezado = true; arrancar(); }, 1200); });
  }

  /* ── 7. Las tres visitas ────────────────────────────── */
  function visitas(el) {
    var lista = el.querySelector('.ct-vis__lista');
    var its = el.querySelectorAll('.ct-vis__it');
    var linea = el.querySelector('.ct-vis__linea');
    if (REDUCE || !lista) return;
    el.classList.add('ct-js');
    raizP(el, 0);
    function pintar() {
      var r = lista.getBoundingClientRect();
      var alto = innerWidth < 860 ? r.height : r.height * 1.6;
      var p = clamp((innerHeight * .8 - r.top) / alto, 0, 1);
      if (linea) linea.style.setProperty('--p', p.toFixed(3));
      each(its, function (it, i) {
        var on = innerWidth < 860 ? it.getBoundingClientRect().top < innerHeight * .72 : p >= i / its.length + .04;
        if (on && !it.__rz) { it.__rz = true; raizCrece(it, 1400, 200); }
        it.classList.toggle('is-on', on);
      });
    }
    var vivo = false;
    vigilar(el, function (v) { vivo = v; if (v) pintar(); });
    alScroll.push(function () { if (vivo) pintar(); });
    pintar();
  }

  /* ── 8. Marquesina ──────────────────────────────────── */
  function marquesina(el) {
    if (REDUCE) return;
    var filas = [];
    each(el.querySelectorAll('.ct-mq__fila'), function (f) {
      var pista = f.querySelector('.ct-mq__pista');
      filas.push({ p: pista, dir: parseFloat(f.getAttribute('data-dir')) || -1, x: 0, mitad: 0 });
    });
    var vivo = false, corriendo = false, ultY = scrollY, vel = 0, t0 = 0;
    function medir() { each(filas, function (f) { f.mitad = f.p.scrollWidth / 2; if (f.dir > 0) f.x = -f.mitad; }); }
    medir();
    addEventListener('resize', medir, { passive: true });
    function cuadro(now) {
      if (!vivo || document.hidden) { corriendo = false; return; }
      var dt = Math.min(.05, (now - (t0 || now)) / 1000); t0 = now;
      var dy = scrollY - ultY; ultY = scrollY;
      vel += (dy - vel) * .15;
      var extra = Math.min(900, Math.abs(vel) * 40);
      var sk = clamp(-vel * .25, -8, 8);
      each(filas, function (f) {
        f.x += f.dir * (60 + extra) * dt;
        if (f.dir < 0 && f.x <= -f.mitad) f.x += f.mitad;
        if (f.dir > 0 && f.x >= 0) f.x -= f.mitad;
        f.p.style.setProperty('--x', f.x.toFixed(1) + 'px');
        f.p.style.setProperty('--sk', sk.toFixed(2) + 'deg');
      });
      requestAnimationFrame(cuadro);
    }
    vigilar(el, function (v) { vivo = v; if (v && !corriendo) { corriendo = true; t0 = 0; ultY = scrollY; requestAnimationFrame(cuadro); } }, '60px 0px');
  }

  /* ── 9. Galería: se destapa, paralaje dentro de cada foto y arrastre con el ratón ── */
  function galeria(el) {
    var pista = el.querySelector('.ct-gal__pista');
    if (!pista) return;
    var imgs = el.querySelectorAll('.ct-gal__marco img');
    function paralaje() {
      var r = pista.getBoundingClientRect(), c = r.left + r.width / 2;
      each(imgs, function (im) { var b = im.parentNode.getBoundingClientRect(); im.style.setProperty('--px', ((b.left + b.width / 2 - c) * -.06).toFixed(1) + 'px'); });
    }
    if (!REDUCE) {
      el.classList.add('ct-js');
      alVer(el, function () { el.classList.add('is-on'); });
      pista.addEventListener('scroll', function () { requestAnimationFrame(paralaje); }, { passive: true });
      paralaje();
    }
    if (FINO) {  // arrastrar con el ratón
      var x0 = 0, s0 = 0, abajo = false, movio = false;
      pista.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; abajo = true; movio = false; x0 = e.clientX; s0 = pista.scrollLeft; });
      addEventListener('pointermove', function (e) {
        if (!abajo) return; var dx = e.clientX - x0;
        if (Math.abs(dx) > 4) { movio = true; pista.classList.add('is-arrastra'); }
        pista.scrollLeft = s0 - dx;
      });
      addEventListener('pointerup', function () { if (!abajo) return; abajo = false; pista.classList.remove('is-arrastra'); });
      pista.addEventListener('click', function (e) { if (movio) { e.preventDefault(); e.stopPropagation(); } }, true);
    }
  }

  /* ── 10. Foto grande: paralaje y zoom suave con el scroll ── */
  function foto(el) {
    var img = el.querySelector('.ct-fb__img img');
    if (REDUCE || !img) return;
    el.classList.add('ct-js');
    alVer(el, function () { el.classList.add('is-on'); });
    var vivo = false;
    vigilar(el, function (v) { vivo = v; if (v) onScroll(); });
    alScroll.push(function () {
      if (!vivo) return;
      var r = el.getBoundingClientRect();
      var p = clamp((innerHeight - r.top) / (innerHeight + r.height), 0, 1);  // 0 entra por abajo, 1 sale por arriba
      img.style.setProperty('--fy', ((p - .5) * -.18 * r.height).toFixed(1) + 'px');
      img.style.setProperty('--fs', (1.12 - p * .08).toFixed(3));
    });
  }

  /* ── Extras de la sección del caso tomate ───────────── */
  function extras(cde) {
    // (Las cifras ya las cuenta caso-estudio.js; aquí no se tocan.)
    // Botones con imán suave (solo ratón)
    if (FINO && !REDUCE) {
      each(cde.querySelectorAll('.cde-btn--p, .ct-btn'), function (btn) {
        btn.addEventListener('pointermove', function (e) {
          var r = btn.getBoundingClientRect();
          btn.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * .18).toFixed(1) + 'px,' + ((e.clientY - r.top - r.height / 2) * .28).toFixed(1) + 'px)';
        });
        btn.addEventListener('pointerleave', function () { btn.style.transform = ''; });
      });
    }
  }

  var ESCENAS = { intro: intro, racimo: racimo, balanza: balanza, fumigaciones: fumigaciones, ciclo: ciclo, raiz: raiz, visitas: visitas, marquesina: marquesina, galeria: galeria, foto: foto };
  function iniciar() {
    each(document.querySelectorAll('.ct[data-ct]'), function (el) {
      if (el.__ct) return; el.__ct = true;
      var fn = ESCENAS[el.getAttribute('data-ct')];
      if (fn) { try { fn(el); } catch (e) { if (window.console) console.warn('caso-tomate', el.getAttribute('data-ct'), e); } }
    });
    each(document.querySelectorAll('.cde[data-ct]'), function (cde) {
      if (cde.__ctx) return; cde.__ctx = true;
      try { extras(cde); } catch (e) {}
    });
    onScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  // Editor de temas: las secciones se recargan sin recargar la página
  document.addEventListener('shopify:section:load', function () { window.__cdeTomate = true; iniciar(); });
})();
